import styled, {css} from 'styled-components';

import ImageWithAlt from '~/shared/components/ImageWithAlt'; import jeOrangeLgLogoUrl from '~/assets/images/je-orange-lg-logo.svg';
import govOrangeLgLogoUrl from '~/assets/images/gov-orange-lg-logo.svg';
import orangeLgLogoUrl from '~/assets/images/orange-lg-logo.svg';
import {isJustEat} from '~/shared/config';
import {media} from '~/shared/theme/media';

type Variant = 'small' | 'large' | 'dynamic';

const smallStyle = css<{isGov?: boolean}>`
  width: ${() => (isJustEat ? 109 : 108)}px;
  height: ${({isGov}) => (isJustEat ? 18 : isGov ? 40 : 32)}px;
`;

const largeStyle = css<{isGov?: boolean}>`
  width: ${() => (isJustEat ? 146 : 135)}px;
  height: ${({isGov}) => (isJustEat ? 24 : isGov ? 48 : 40)}px;
`;

const dynamicStyle = css<{isGov?: boolean}>`
  ${smallStyle}
  ${media.minLargeMobile`
    ${largeStyle}
  `}
`;

const variantMap = {
  small: smallStyle,
  large: largeStyle,
  dynamic: dynamicStyle,
};

const BrandLogo = styled(ImageWithAlt).attrs<{isGov?: boolean}>(({isGov}) => ({
  alt: 'Logo',
  src: isJustEat ? jeOrangeLgLogoUrl : isGov ? govOrangeLgLogoUrl : orangeLgLogoUrl,
}))<{isGov?: boolean; variant?: Variant}>`
  ${({variant}) => (variant ? variantMap[variant] : dynamicStyle)}
`;

export default BrandLogo;
